// MyProjectIcons.js
import React from 'react';

export const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
  >
    <path
      d="M5.35714 7.14286H0.892857C0.639881 7.14286 0.427827 7.05729 0.256696 6.88616C0.0855655 6.71503 0 6.50298 0 6.25C0 5.99702 0.0855655 5.78497 0.256696 5.61384C0.427827 5.44271 0.639881 5.35714 0.892857 5.35714H5.35714V0.892857C5.35714 0.639881 5.44271 0.427827 5.61384 0.256696C5.78497 0.0855655 5.99702 0 6.25 0C6.50298 0 6.71503 0.0855655 6.88616 0.256696C7.05729 0.427827 7.14286 0.639881 7.14286 0.892857V5.35714H11.6071C11.8601 5.35714 12.0722 5.44271 12.2433 5.61384C12.4144 5.78497 12.5 5.99702 12.5 6.25C12.5 6.50298 12.4144 6.71503 12.2433 6.88616C12.0722 7.05729 11.8601 7.14286 11.6071 7.14286H7.14286V11.6071C7.14286 11.8601 7.05729 12.0722 6.88616 12.2433C6.71503 12.4144 6.50298 12.5 6.25 12.5C5.99702 12.5 5.78497 12.4144 5.61384 12.2433C5.44271 12.0722 5.35714 11.8601 5.35714 11.6071V7.14286Z"
      fill="#EAF7FF"
    />
  </svg>
);

export const DotsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="3" viewBox="0 0 12 3" fill="none">
  <path d="M1.39895 2.22795C1.01424 2.22795 0.684902 2.11888 0.410941 1.90072C0.13698 1.68257 0 1.42032 0 1.11398C0 0.807633 0.13698 0.545385 0.410941 0.327231C0.684902 0.109077 1.01424 0 1.39895 0C1.78366 0 2.11299 0.109077 2.38695 0.327231C2.66092 0.545385 2.7979 0.807633 2.7979 1.11398C2.7979 1.42032 2.66092 1.68257 2.38695 1.90072C2.11299 2.11888 1.78366 2.22795 1.39895 2.22795ZM5.59579 2.22795C5.21108 2.22795 4.88174 2.11888 4.60778 1.90072C4.33382 1.68257 4.19684 1.42032 4.19684 1.11398C4.19684 0.807633 4.33382 0.545385 4.60778 0.327231C4.88174 0.109077 5.21108 0 5.59579 0C5.9805 0 6.30984 0.109077 6.5838 0.327231C6.85776 0.545385 6.99474 0.807633 6.99474 1.11398C6.99474 1.42032 6.85776 1.68257 6.5838 1.90072C6.30984 2.11888 5.9805 2.22795 5.59579 2.22795ZM9.79263 2.22795C9.40792 2.22795 9.07859 2.11888 8.80463 1.90072C8.53067 1.68257 8.39369 1.42032 8.39369 1.11398C8.39369 0.807633 8.53067 0.545385 8.80463 0.327231C9.07859 0.109077 9.40792 0 9.79263 0C10.1773 0 10.5067 0.109077 10.7806 0.327231C11.0546 0.545385 11.1916 0.807633 11.1916 1.11398C11.1916 1.42032 11.0546 1.68257 10.7806 1.90072C10.5067 2.11888 10.1773 2.22795 9.79263 2.22795Z" fill="#8B55DD"/>
</svg>
);

export const ShareIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 15 17"
    fill="none"
  >
    <path
      d="M12.5 16.6667C11.8056 16.6667 11.2153 16.4236 10.7292 15.9375C10.2431 15.4514 10 14.8611 10 14.1667C10 14.0833 10.0208 13.8889 10.0625 13.5833L4.20833 10.1667C3.98611 10.375 3.72917 10.5382 3.4375 10.6562C3.14583 10.7743 2.83333 10.8333 2.5 10.8333C1.80556 10.8333 1.21528 10.5903 0.729167 10.1042C0.243056 9.61806 0 9.02778 0 8.33333C0 7.63889 0.243056 7.04861 0.729167 6.5625C1.21528 6.07639 1.80556 5.83333 2.5 5.83333C2.83333 5.83333 3.14583 5.89236 3.4375 6.01042C3.72917 6.12847 3.98611 6.29167 3.98611 6.29167L10.0625 3.08333C10.0347 2.98611 10.0174 2.89236 10.0104 2.80208C10.0035 2.71181 10 2.61111 10 2.5C10 1.80556 10.2431 1.21528 10.7292 0.729167C11.2153 0.243056 11.8056 0 12.5 0C13.1944 0 13.7847 0.243056 14.2708 0.729167C14.7569 1.21528 15 1.80556 15 2.5C15 3.19444 14.7569 3.78472 14.2708 4.27083C13.7847 4.75694 13.1944 5 12.5 5C12.1667 5 11.8542 4.94097 11.5625 4.82292C11.2708 4.70486 11.0139 4.54167 10.7917 4.33333L4.9375 7.75C4.96528 7.84722 4.98264 7.94097 4.98958 8.03125C4.99653 8.12153 5 8.22222 5 8.33333C5 8.44444 4.99653 8.54514 4.98958 8.63542C4.98264 8.72569 4.96528 8.81944 4.9375 8.91667L10.7917 12.3333C11.0139 12.125 11.2708 11.9618 11.5625 11.8438C11.8542 11.7257 12.1667 11.6667 12.5 11.6667C13.1944 11.6667 13.7847 11.9097 14.2708 12.3958C14.7569 12.8819 15 13.4722 15 14.1667C15 14.8611 14.7569 15.4514 14.2708 15.9375C13.7847 16.4236 13.1944 16.6667 12.5 16.6667ZM12.5 15C12.7361 15 12.934 14.9201 13.0938 14.7604C13.2535 14.6007 13.3333 14.4028 13.3333 14.1667C13.3333 13.9306 13.2535 13.7326 13.0938 13.5729C12.934 13.4132 12.7361 13.3333 12.5 13.3333C12.2639 13.3333 12.066 13.4132 11.9062 13.5729C11.7465 13.7326 11.6667 13.9306 11.6667 14.1667C11.6667 14.4028 11.7465 14.6007 11.9062 14.7604C12.066 14.9201 12.2639 15 12.5 15ZM2.5 9.16667C2.73611 9.16667 2.93403 9.08681 3.09375 8.92708C3.25347 8.76736 3.33333 8.56944 3.33333 8.33333C3.33333 8.09722 3.25347 7.89931 3.09375 7.73958C2.93403 7.57986 2.73611 7.5 2.5 7.5C2.26389 7.5 2.06597 7.57986 1.90625 7.73958C1.74653 7.89931 1.66667 8.09722 1.66667 8.33333C1.66667 8.56944 1.74653 8.76736 1.90625 8.92708C2.06597 9.08681 2.26389 9.16667 2.5 9.16667ZM12.5 3.33333C12.7361 3.33333 12.934 3.25347 13.0938 3.09375C13.2535 2.93403 13.3333 2.73611 13.3333 2.5C13.3333 2.26389 13.2535 2.06597 13.0938 1.90625C12.934 1.74653 12.7361 1.66667 12.5 1.66667C12.2639 1.66667 12.066 1.74653 11.9062 1.90625C11.7465 2.06597 11.6667 2.26389 11.6667 2.5C11.6667 2.73611 11.7465 2.93403 11.9062 3.09375C12.066 3.25347 12.2639 3.33333 12.5 3.33333Z"
      fill="currentColor"
    />
  </svg>
);

export const RenameIcon = ({ hovered }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="19"
    viewBox="0 0 17 19"
    fill={hovered ? "#C95EBE" : "currentColor"}
  >
    <path
      d="M1.66667 18.3333C1.20833 18.3333 0.815972 18.1701 0.489583 17.8438C0.163194 17.5174 0 17.125 0 16.6667C0 16.2083 0.163194 15.816 0.489583 15.4896C0.815972 15.1632 1.20833 15 1.66667 15H15C15.4583 15 15.8507 15.1632 16.1771 15.4896C16.5035 15.816 16.6667 16.2083 16.6667 16.6667C16.6667 17.125 16.5035 17.5174 16.1771 17.8438C15.8507 18.1701 15.4583 18.3333 15 18.3333H1.66667ZM3.33333 11.6667H4.5L11 5.1875L9.8125 4L3.33333 10.5V11.6667ZM1.66667 12.5V10.1458C1.66667 10.0347 1.6875 9.92708 1.72917 9.82292C1.77083 9.71875 1.83333 9.625 1.91667 9.54167L11 0.479167C11.1528 0.326389 11.3299 0.208333 11.5312 0.125C11.7326 0.0416667 11.9444 0 12.1667 0C12.3889 0 12.6042 0.0416667 12.8125 0.125C13.0208 0.208333 13.2083 0.333333 13.375 0.5L14.5208 1.66667C14.6875 1.81944 14.809 2 14.8854 2.20833C14.9618 2.41667 15 2.63194 15 2.85417C15 3.0625 14.9618 3.26736 14.8854 3.46875C14.809 3.67014 14.6875 3.85417 14.5208 4.02083L5.45833 13.0833C5.375 13.1667 5.28125 13.2292 5.17708 13.2708C5.07292 13.3125 4.96528 13.3333 4.85417 13.3333H2.5C2.26389 13.3333 2.06597 13.2535 1.90625 13.0938C1.74653 12.934 1.66667 12.7361 1.66667 12.5Z"
      fill={hovered ? "#C95EBE" : "currentColor"}
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    width="20"
    height="20"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
    />
  </svg>
);

export const AddNotesIcon = () => (
  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    width="19"
    height="19"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.8}
      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    />
  </svg>
);

export const ArchiveIcon = () => (
  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    width="19"
    height="19"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.8}
      d="M3 7l1.5-3h15L21 7M3 7v12a2 2 0 002 2h14a2 2 0 002-2V7M3 7h18M10 12h4"
    />
  </svg>
);

export const UnarchiveIcon = () => (
  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    width="19"
    height="19"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.8}
      d="M3 7l1.5-3h15L21 7M3 7v12a2 2 0 002 2h14a2 2 0 002-2V7M3 7h18M12 15V9m0 0l-2.5 2.5M12 9l2.5 2.5"
    />
  </svg>
);

// Hand a project to another member (two arrows swapping direction).
export const TransferIcon = () => (
  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    width="19"
    height="19"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.8}
      d="M7 16H3m0 0l3-3m-3 3l3 3M17 8h4m0 0l-3-3m3 3l-3 3"
    />
  </svg>
);

// Shown on projects shared with the current user — remove yourself from the
// project (door with an outbound arrow).
export const LeaveIcon = () => (
  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    width="19"
    height="19"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.8}
      d="M15 17l5-5m0 0l-5-5m5 5H9m3 7H6a2 2 0 01-2-2V7a2 2 0 012-2h6"
    />
  </svg>
);

export const ProjectDetailsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
  >
    <path
      d="M1.66667 11.6667V1.66667V5.58333V5V11.6667ZM1.66667 13.3333C1.20833 13.3333 0.815972 13.1701 0.489583 12.8438C0.163194 12.5174 0 12.125 0 11.6667V1.66667C0 1.20833 0.163194 0.815972 0.489583 0.489583C0.815972 0.163194 1.20833 0 1.66667 0H6.66667L8.33333 1.66667H15C15.4583 1.66667 15.8507 1.82986 16.1771 2.15625C16.5035 2.48264 16.6667 2.875 16.6667 3.33333V5.35417C16.6667 5.59028 16.5868 5.78472 16.4271 5.9375C16.2674 6.09028 16.0694 6.16667 15.8333 6.16667C15.5972 6.16667 15.3993 6.08681 15.2396 5.92708C15.0799 5.76736 15 5.56944 15 5.33333V3.33333H7.64583L5.97917 1.66667H1.66667V11.6667H6.14583C6.38194 11.6667 6.57986 11.7465 6.73958 11.9062C6.89931 12.066 6.97917 12.2639 6.97917 12.5C6.97917 12.7361 6.89931 12.934 6.73958 13.0938C6.57986 13.2535 6.38194 13.3333 6.14583 13.3333H1.66667ZM12.5 6.66667C13.6528 6.66667 14.6354 7.07292 15.4479 7.88542C16.2604 8.69792 16.6667 9.68056 16.6667 10.8333C16.6667 11.9861 16.2604 12.9688 15.4479 13.7812C14.6354 14.5938 13.6528 15 12.5 15C11.3472 15 10.3646 14.5938 9.55208 13.7812C8.73958 12.9688 8.33333 11.9861 8.33333 10.8333C8.33333 9.68056 8.73958 8.69792 9.55208 7.88542C10.3646 7.07292 11.3472 6.66667 12.5 6.66667ZM12.5 13.3333C12.6111 13.3333 12.7083 13.2917 12.7917 13.2083C12.875 13.125 12.9167 13.0278 12.9167 12.9167V10.4167C12.9167 10.3056 12.875 10.2083 12.7917 10.125C12.7083 10.0417 12.6111 10 12.5 10C12.3889 10 12.2917 10.0417 12.2083 10.125C12.125 10.2083 12.0833 10.3056 12.0833 10.4167V12.9167C12.0833 13.0278 12.125 13.125 12.2083 13.2083C12.2917 13.2917 12.3889 13.3333 12.5 13.3333ZM12.5 9.16667C12.6111 9.16667 12.7083 9.125 12.7917 9.04167C12.875 8.95833 12.9167 8.86111 12.9167 8.75C12.9167 8.63889 12.875 8.54167 12.7917 8.45833C12.7083 8.375 12.6111 8.33333 12.5 8.33333C12.3889 8.33333 12.2917 8.375 12.2083 8.45833C12.125 8.54167 12.0833 8.63889 12.0833 8.75C12.0833 8.86111 12.125 8.95833 12.2083 9.04167C12.2917 9.125 12.3889 9.16667 12.5 9.16667Z"
      fill="currentColor"
    />
  </svg>
);
